












import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportInProgress from '@/componentsV2/templates/CustomerImportInProgress/CustomerImportInProgress.vue';
import { ICustomerImportStatus } from '@/models/customer-import';
import { EEmptyStateTabs } from './CustomerImportEmptyState.vue';

@Component({
  components: {
    CustomerImportInProgress
  }
})
export default class CustomerImportProgress extends Vue {
  @Prop() customerImportData!: ICustomerImportStatus;

  handleFailed() {
    this.$emit('empty-state-event', {
      type: 'goTo',
      data: { step: EEmptyStateTabs.ERROR }
    });
  }

  handleCompleted(customerImportStatus: ICustomerImportStatus) {
    this.$emit('empty-state-event', {
      type: 'goTo',
      data: { step: EEmptyStateTabs.SUCCESS, stepProps: customerImportStatus }
    });
  }
}
